<template>
    <div class="gridView-page h-100 ingridView-temp">
        <!-- <app-modify-order v-if="modifyOrder == 'true'"></app-modify-order>
        <app-pending-order v-show="pendingOrder"></app-pending-order> -->
        <app-buy-sell v-if="tradeBuySell" :buySellType="buySellType" :currency_pair="currency_pair"></app-buy-sell>
        <notifications class="whitelist" group="whitelist" style="z-index: 99999" position="top left" :max="1"
            v-if="$route.name != 'chart'" />
        <div class="fullPageTable fixed-for-mobile-fotter">
            <div class="topHead d-flex justify-content-between align-items-center">
                <ul class="tbs d-flex">
                    <li :class="orderTab == 'Market' ? 'active' : ' '" @click.prevent="orderTab = 'Market'">
                        <a href="#"><svg class="footer-nav-icon" width="20" height="21" viewBox="0 0 20 21" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M15.2826 11.5652C15.2826 11.2891 15.5065 11.0652 15.7826 11.0652H19C19.2761 11.0652 19.5 11.2891 19.5 11.5652V20C19.5 20.2761 19.2761 20.5 19 20.5H15.7826C15.5065 20.5 15.2826 20.2761 15.2826 20V11.5652ZM7.8913 12.8696C7.8913 12.5934 8.11516 12.3696 8.3913 12.3696H11.6087C11.8848 12.3696 12.1087 12.5934 12.1087 12.8696V20C12.1087 20.2761 11.8848 20.5 11.6087 20.5H8.3913C8.11516 20.5 7.8913 20.2761 7.8913 20V12.8696ZM0.5 14.1739C0.5 13.8978 0.723858 13.6739 1 13.6739H4.21739C4.49353 13.6739 4.71739 13.8978 4.71739 14.1739V20C4.71739 20.2761 4.49353 20.5 4.21739 20.5H1C0.723857 20.5 0.5 20.2761 0.5 20V14.1739Z"
                                    stroke="#999A9B"></path>
                                <path d="M19.2025 1L11.2858 9.26087L7.11914 4.91304L0.869141 11.4348" stroke="#999A9B"
                                    stroke-linecap="round" stroke-linejoin="round"></path>
                                <path d="M14.2031 1H19.2031V6.21739" stroke="#999A9B" stroke-linecap="round"
                                    stroke-linejoin="round"></path>
                            </svg>
                            {{ $t('market_watch') }}</a>
                    </li>
                    <li :class="orderTab == 'Charts' ? 'active' : ' '" @click.prevent="orderTab = 'Charts'">
                        <a href="#"><svg class="footer-nav-icon" width="20" height="20" viewBox="0 0 20 20" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M12.2272 0.851051H2.62012C1.65542 0.851051 0.873373 1.61311 0.873373 2.55315V15.3189C0.873373 16.259 1.65542 17.021 2.62012 17.021H12.2272V17.8721H2.62012C1.17307 17.8721 0 16.729 0 15.3189V2.55315C0 1.14309 1.17307 0 2.62012 0H12.2272C13.6743 0 14.8473 1.14309 14.8473 2.55315V11.4892H13.974V2.55315C13.974 1.61311 13.1919 0.851051 12.2272 0.851051Z"
                                    fill="#999A9B"></path>
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M11.1808 11.5551C11.2963 11.4063 11.4768 11.3188 11.6683 11.3188H17.1764C17.3554 11.3188 17.5253 11.3952 17.6415 11.5278L19.8537 14.0538C20.0542 14.2828 20.0479 14.6214 19.8392 14.8432L15.5547 19.3952C15.4106 19.6074 15.1344 19.8899 14.7401 19.9751C14.2833 20.0737 13.8336 19.8783 13.4571 19.4122L9.15865 14.9839C8.95334 14.7723 8.935 14.4472 9.11528 14.215L11.1808 11.5551ZM11.7986 12.1699L9.94563 14.5561L14.1209 18.8576L14.1342 18.8745C14.2593 19.0323 14.3589 19.0993 14.4214 19.1269C14.4779 19.1519 14.5177 19.1514 14.5511 19.1442C14.641 19.1248 14.7545 19.0351 14.831 18.9186C14.8489 18.8915 14.8704 18.8631 14.8969 18.835L19.0389 14.4345L17.0556 12.1699H11.7986ZM16.9771 12.0803C16.9771 12.0802 16.9772 12.0804 16.9771 12.0803V12.0803Z"
                                    fill="#999A9B"></path>
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M13.4339 15.5956L12.2221 13.9496L12.9317 13.4535L14.1435 15.0995C14.3177 15.3362 14.6789 15.3362 14.8532 15.0995L16.0649 13.4535L16.7746 13.9496L15.5628 15.5956C15.0401 16.3055 13.9565 16.3055 13.4339 15.5956Z"
                                    fill="#999A9B"></path>
                                <path
                                    d="M3.15745 4.00011C3.15745 3.76509 3.35296 3.57458 3.59413 3.57458H10.7907C11.0319 3.57458 11.2274 3.76509 11.2274 4.00011C11.2274 4.23512 11.0319 4.42563 10.7907 4.42563H3.59413C3.35296 4.42563 3.15745 4.23512 3.15745 4.00011Z"
                                    fill="#999A9B"></path>
                                <path
                                    d="M3.15745 7.57469C3.15745 7.33967 3.35296 7.14916 3.59413 7.14916H7.98378C8.22496 7.14916 8.42047 7.33967 8.42047 7.57469C8.42047 7.8097 8.22496 8.00021 7.98378 8.00021H3.59413C3.35296 8.00021 3.15745 7.8097 3.15745 7.57469Z"
                                    fill="#999A9B"></path>
                                <path
                                    d="M3.15745 11.1484C3.15745 10.9134 3.35296 10.7229 3.59413 10.7229H6.58031C6.82148 10.7229 7.017 10.9134 7.017 11.1484C7.017 11.3834 6.82148 11.574 6.58031 11.574H3.59413C3.35296 11.574 3.15745 11.3834 3.15745 11.1484Z"
                                    fill="#999A9B"></path>
                            </svg>
                            {{ $t('charts') }}</a>
                    </li>
                    <li :class="orderTab == 'Trade' ? 'active' : ' '" @click.prevent="orderTab = 'Trade'">
                        <a href="#">
                            <svg class="footer-nav-icon" width="50" height="48" viewBox="0 0 50 48" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <rect x="17.9839" y="19.5664" width="12.621" height="22.2177" />
                                <rect x="37.3792" y="14.1602" width="12.621" height="22.2177" />
                                <rect y="8.75781" width="12.621" height="27.621" fill="white" />
                                <rect x="22.0564" y="11.6211" width="4.47581" height="35.5645" />
                                <rect x="41.4514" y="6.21875" width="4.47581" height="35.5645" />
                                <rect x="4.07251" y="0.816406" width="4.47581" height="46.371" />
                            </svg>

                            {{ $t('trade_log') }}</a>
                    </li>
                    <!-- <li :class="(orderTab == 'transition-history')?'active':' '" @click.prevent="orderTab = 'transition-history'">
                        <a href="#">Transaction History</a>
                    </li> -->
                </ul>
                <div class="d-flex align-items-center hide-search-bar-mobile">
                    <!-- <div class="toggle-button-cover d-flex align-items-center floating mr-2 gridTole" :class="dfUsed?'active':' '" v-if="orderTab == 'Market'">
                        <input type="checkbox" id="sdf" @click="dfUsed = !dfUsed" />
                        <label>
                            <span class="ml-0"></span>
                            <p class="fixedTR">Last Used</p>
                            <p class="floatingTR">Default Size</p>
                        </label>
                    </div> -->
                    <div class="addWatch_list updateWrap d-flex align-items-center justify-content-between"
                        v-if="orderTab == 'Market'">
                        <ul class="d-flex align-items-center justify-content-between comp-toggle border-0">
                            <li>
                                <div class="dropdown">
                                    <button type="button" class="btn appButton dropdown-toggle custom"
                                        data-toggle="dropdown">
                                        {{ getwatchName(watchId) }}
                                    </button>
                                    <div class="dropdown-menu myWatchlist">
                                        <a @click.prevent="showCreateWatch = !showCreateWatch"
                                            class="dropdown-item d-flex align-items-center crtWatlist" href="#">
                                            <feather class="mr-2" size="13px" type="plus-circle"></feather>
                                            {{$t('create_new_watchlist') }}
                                        </a>
                                        <a class="dropdown-item justify-content-between" href="#"
                                            v-for="list in watchListData" @click.prevent="setWatch(list)">
                                            {{ list.name }}
                                            <span class="d-flex align-items-center" v-if="list._id">
                                                <span @click.prevent="editWatchData = list" class="editClose mr-1">
                                                    <feather size="13px" type="edit"></feather>
                                                </span>
                                                <span @click.prevent="delWatchData = list" class="editClose">
                                                    <feather class="red" size="14px" type="trash-2"></feather>
                                                </span>
                                            </span>
                                        </a>
                                        <!-- <a class="dropdown-item" href="#">Watchlist 2</a>
								    	<a class="dropdown-item" href="#">Watchlist 3</a> -->
                                    </div>
                                </div>
                            </li>
                            <!-- <li :class="(symbolType == 'Symbols')?'active':' '">
				            	<a @click.prevent="symbolType = 'Symbols' " href="#stocks"> All Symbols</a>
				            </li> -->
                        </ul>
                    </div>
                    <div class="addWatch_list updateWrap d-flex align-items-center justify-content-between ml-3"
                        v-if="orderTab == 'Market'">
                        <ul class="d-flex align-items-center justify-content-between comp-toggle border-0">
                            <li>
                                <div class="dropdown customDrop searchIsinFilter">
                                    <!-- <button type="button" class="btn appButton dropdown-toggle" data-toggle="dropdown">
                                        Search 
                                    </button> -->
                                    <div class="search_share_sec d-flex align-items-center m-0">
                                        <feather type="search"></feather>
                                        <input type="text" placeholder="Search here..." id="search_share"
                                            v-model="filterCrypto" class="search_txtin" @focus="focusSearch = true"
                                            autocomplete="off" />
                                    </div>
                                    <div class="dropdown-menu" :class="filterCrypto || focusSearch ? 'show' : ''"
                                        @click.stop="">
                                        <div class="scrollbar searchList" @click.stop="">
                                            <a class="dropdown-item justify-content-between" href="#"
                                                v-for="spreads in currencyPairs" v-if="
                                                    spreads.isinid
                                                        .toLowerCase()
                                                        .includes(filterCrypto.toLowerCase())
                                                ">
                                                {{ spreads.isinid }}
                                                <span class="d-flex align-items-center">
                                                    <span @click.prevent="addRemSubscribe(spreads.isinid, spreads.mn)"
                                                        class="editClose">
                                                        <feather size="13px" :type="subList.includes(spreads.isinid.slice(0, 6))
                                                                ? 'x'
                                                                : 'plus'
                                                            " :style="subList.includes(spreads.isinid.slice(0, 6))
                                                            ? 'color:red;'
                                                            : null
                                                        "></feather>
                                                    </span>
                                                </span>
                                            </a>
                                            <no-data class="noData border-0 h-100 text-center"
                                                v-if="currencyPairs.length == 0 || filtercurr().length == 0"
                                                text="No result found" />
                                        </div>
                                        <!-- <a class="dropdown-item" href="#">Watchlist 2</a>
                                        <a class="dropdown-item" href="#">Watchlist 3</a> -->
                                    </div>
                                </div>
                            </li>
                            <!-- <li :class="(symbolType == 'Symbols')?'active':' '">
                                <a @click.prevent="symbolType = 'Symbols' " href="#stocks"> All Symbols</a>
                            </li> -->
                        </ul>
                    </div>
                    <div class="addFavorite" @click="
                        shoWFev = !shoWFev;
                        isSearch = false;
                        " v-if="watchId && orderTab == 'Market'" :class="[{ active: shoWFev }]">
                        <a href="#" class="d-flex align-items-center btn appButton"
                            :class="[{ favSelected: shoWFev }]"><!-- , 'enable': fevList.length > 0 -->
                            <feather size="14px" class="mr-2" type="star"></feather> {{ $t('favorite') }}
                        </a>
                    </div>
                    <div class="toggle-button-cover d-flex align-items-center" v-if="orderTab == 'Market'">
                        <input type="checkbox" id="sdf" @click="oneClickTrade = !oneClickTrade" />
                        <label>
                            <span></span>
                            <p class="afterGreen">{{ $t('one_click_trading') }}</p>
                        </label>
                    </div>
                    <!-- <div class="toggle-button-cover d-flex align-items-center" v-else-if="orderTab == 'Charts'">
                        <span></span>
                    </div>
                    <div class="formSelect-date" v-else-if="orderTab == 'Trade'">
                        <form class="updateWrap">
                            <div class="twoColmn d-flex align-items-center">
                                <p class="f-12 mb-0">Time Range:</p>
                                <div class="form-fields d-flex align-items-center">
                                    <p class="mb-0">(From)</p>
                                    <select class="selectBox">
                                        <option>Time Zone</option>
                                        <option>Time Zone</option>
                                        <option>Time Zone</option>
                                        <option>Time Zone</option>
                                    </select>
                                    <div class="fromTO d-flex align-items-center">
                                        <p class="mb-0">(To)</p>
                                        <select class="selectBox">
                                            <option>Time Zone</option>
                                            <option>Time Zone</option>
                                            <option>Time Zone</option>
                                            <option>Time Zone</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div> -->
                </div>
            </div>
        </div>
        <div class="orderTab-bottom calHeightInc">
            <div class="responsiveTable scrollbar bottomTable" v-show="orderTab == 'Market'">
                <!-- <app-pair-detail v-if="detailISIN" :pair="detailISIN"></app-pair-detail> -->
                <table class="table table-hover text-center last-child rightLast-child">
                    <thead>
                        <tr>
                            <!-- <th>S.No</th> -->
                            <th>{{ $t('b-instrument') }}</th>
                            <th>{{ $t('bid') }}</th>
                            <th>{{ $t('ask') }}</th>
                            <th v-show="!isMobileGrid() && !(userSettings.position_size && userSettings.display_spread == '0')">{{ $t('spread') }}</th>
                            <th v-show="!isMobileGrid() && !(userSettings.display_high_low && userSettings.display_high_low == '0')">{{$t('high')}}</th>
                            <th v-show="!isMobileGrid() && !(userSettings.display_high_low && userSettings.display_high_low == '0')">{{ $t('low') }}</th>
                            <!-- <th>Volume</th> -->
                            <th v-show='!isMobileGrid()'>{{ $t('change') }}</th>
                            <th v-show='!isMobileGrid()'>{{ $t('change') }}%</th>
                            <th v-show='!isMobileGrid()'>{{ $t('descrption') }}</th>
                            <th v-show='!isMobileGrid()'>{{ $t('asset_class') }}</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(spreads, index) in dataList(get_currencies)">
                            <!-- <td>{{index+1}}</td> -->
                            <td>
                                {{ spreads.other.isinid }} {{ index == 0 ? showdata(spreads) : null }}
                            </td>
                            <td class="linkColor" :class="[{'green': spreads.buy_increase_staus}, {'red': !spreads.buy_increase_staus}]">
                                {{ Number(spreads.B || 0).toFixed((((spreads.other.Tick_Size || '').split('.')[1] || '').length) || 1) }}
                            </td>
                            <td :class="[ { 'green': spreads.sell_increase_staus }, { 'red': !spreads.sell_increase_staus }, ]">
                                {{ Number(spreads.A || 0).toFixed((((spreads.other.Tick_Size || '').split('.')[1] || '').length) || 1) }}
                            </td>
                            <td v-show="!isMobileGrid() && !(userSettings.position_size && userSettings.display_spread == '0')">
                                <!-- {{ spreads.SPREAD || getSpread(spreads) }} -->
                                {{parseFloat((spreads.SPREAD/spreads.other.pip_size).toFixed(1))}}
                            </td>
                            <td v-show='!isMobileGrid()'>{{ spreads.HIGH }}</td>
                            <td v-show='!isMobileGrid()'>{{ spreads.LOW }}</td>
                            <!-- <td>{{spreads.VOLUME || '-'}}</td> -->
                            <td v-show='!isMobileGrid()' :class="[
                                { green: parseFloat((spreads.B - spreads.other.closepx).toFixed(3)) > 0,},
                                { red: parseFloat((spreads.B - spreads.other.closepx).toFixed(3)) < 0 }
                            ]">
                                {{ parseFloat((spreads.B - spreads.other.closepx).toFixed((((spreads.other.Tick_Size || '').split('.')[1] || '').length) || 1)) }}
                            </td>
                            <td v-show='!isMobileGrid()' :class="[ { green: spreads.B - spreads.other.closepx > 0 }, { red: spreads.B - spreads.other.closepx < 0 } ]">
                                {{ parseFloat((((spreads.B - spreads.other.closepx) / spreads.other.closepx) * 100 ).toFixed(2)) }}%
                            </td>
                            <td v-show='!isMobileGrid()'>{{ spreads.other.Description || '-' }}</td>
                            <td v-show='!isMobileGrid()'>
                                <span class="yellowBG pad">{{ assetType[spreads.other.type.toLowerCase()] || spreads.other.type}}</span>
                            </td>
                            <td v-if="oneClickTrade">
                                <span class="customAction">
                                    <div class="form-data d-flex align-items-center" @click.stop.prevent="">
                                        <div class="form-fields d-flex align-items-center midSpace"
                                            :id="spreads.other.isinid + '_form_SL'">
                                            <label>{{ $t('sl') }}</label>
                                            <div class="onclick-input" v-if="onClickList[spreads.other.isinid]">
                                                <a href="#" @click.prevent="changeStep(spreads.other.isinid, 1, 'SL')">
                                                    <feather type="plus"></feather>
                                                </a>
                                                <input type="number"
                                                    :step="getStep(onClickList[spreads.other.isinid].SL, spreads)"
                                                    min="0" placeholder="0.00" :id="spreads.other.isinid + '_SL'"
                                                    v-model="onClickList[spreads.other.isinid].SL" @input="
                                                        changeValidation(
                                                            spreads.other.isinid,
                                                            onClickList[spreads.other.isinid].SL,
                                                            'SL',
                                                            spreads
                                                        );
                                                    removeErrorMsg(spreads.other.isinid + '_form_SL');
                                                    " maxlength="11" @keyup="keyUpStep($event, spreads.other.isinid, 'SL')" />
                                                <a class="minus" href="#"
                                                    @click.prevent="changeStep(spreads.other.isinid, 0, 'SL')">
                                                    <feather type="minus"></feather>
                                                </a>
                                            </div>
                                            <input type="number" step="0.01" min="0" placeholder="0.00" v-else />
                                        </div>
                                        <div class="form-fields d-flex align-items-center midSpace"
                                            :id="spreads.other.isinid + '_form_TP'">
                                            <label>{{ $t('tp') }}</label>
                                            <div class="onclick-input" v-if="onClickList[spreads.other.isinid]">
                                                <a href="#" @click.prevent="changeStep(spreads.other.isinid, 1, 'TP')">
                                                    <feather type="plus"></feather>
                                                </a>
                                                <input type="number"
                                                    :step="getStep(onClickList[spreads.other.isinid].TP, spreads)"
                                                    min="0" placeholder="0.00" :id="spreads.other.isinid + '_TP'"
                                                    v-model="onClickList[spreads.other.isinid].TP" @input="
                                                        changeValidation(
                                                            spreads.other.isinid,
                                                            onClickList[spreads.other.isinid].TP,
                                                            'TP',
                                                            spreads
                                                        );
                                                    removeErrorMsg(spreads.other.isinid + '_form_TP');
                                                    " maxlength="11" @keyup="keyUpStep($event, spreads.other.isinid, 'TP')" />
                                                <a class="minus" href="#"
                                                    @click.prevent="changeStep(spreads.other.isinid, 0, 'TP')">
                                                    <feather type="minus"></feather>
                                                </a>
                                            </div>
                                            <input type="number" step="0.01" min="0" placeholder="0.00" v-else />
                                        </div>
                                    </div>
                                    <div class="form-data d-flex align-items-center" @click.stop.prevent="">
                                        <a href="#" @click.prevent="oneClickOrder(spreads.other.isinid, 0, spreads)"
                                            class="button-fields redBG midSpace">
                                            <span class="sm"> {{$t('sell')}}</span>
                                            <p class="mb-0 f-12">{{ parseFloat(spreads.B || 0).toFixed(4) }}</p>
                                        </a>
                                        <div class="button-fields form-fields p-0 midSpace"
                                            :id="spreads.other.isinid + '_form_lot'">
                                            <div class="onclick-input outMid" v-if="onClickList[spreads.other.isinid]">
                                                <a href="#" @click.prevent="changeStep(spreads.other.isinid, 1, 'lot')">
                                                    <feather type="plus"></feather>
                                                </a>
                                                <input type="number" placeholder="0.01" step="0.01" min="0.01"
                                                    class="boxInput" :name="spreads.other.isinid + '_lot'"
                                                    :id="spreads.other.isinid + '_lot'"
                                                    v-model="onClickList[spreads.other.isinid].lot" @input="
                                                        quantityValidation(
                                                            spreads.other.isinid,
                                                            onClickList[spreads.other.isinid].lot,
                                                            spreads
                                                        );
                                                    removeErrorMsg(spreads.other.isinid + '_form_lot');
                                                    " maxlength="10" />
                                                <a class="minus" href="#"
                                                    @click.prevent="changeStep(spreads.other.isinid, 0, 'lot')">
                                                    <feather type="minus"></feather>
                                                </a>
                                            </div>
                                            <input type="number" placeholder="0.01" step="0.01" min="0" class="boxInput"
                                                :name="spreads.other.isinid + '_lot'"
                                                :id="spreads.other.isinid + '_lot'" v-else />
                                            <!-- <input type="number" step="0.01" min="0" placeholder="0.01" :name="spreads.other.isinid+'_lot'" :id="spreads.other.isinid+'_lot'" v-model="onClickList[spreads.other.isinid].lot" class="boxInput" v-if="onClickList[spreads.other.isinid]"/>
                                            <input type="number" step="0.01" min="0" placeholder="0.01" :name="spreads.other.isinid+'_lot'" :id="spreads.other.isinid+'_lot'" v-else/> -->
                                        </div>
                                        <a href="#" @click.prevent="oneClickOrder(spreads.other.isinid, 1, spreads)"
                                            class="button-fields greenBG midSpace">
                                            <span class="sm"> {{$t('buy')}}</span>
                                            <p class="mb-0 f-12">{{ parseFloat(spreads.A || 0).toFixed(4) }}</p>
                                        </a>
                                    </div>
                                </span>
                            </td>
                            <td v-else>
                                <span class="p-text d-inline-flex">
                                    <a class="td-button" href="#" @click.prevent="detailISIN = spreads.other.isinid"
                                        v-show='!isMobileGrid()'>
                                        <feather size="12px" type="info"></feather>
                                    </a>
                                    <a href="#" class="td-button sell"
                                        @click.prevent.stop="openBuySell('sell', spreads.other.isinid)">S
                                    </a>
                                    <a href="#" class="td-button buy"
                                        @click.prevent.stop="openBuySell('buy', spreads.other.isinid)">B
                                    </a>
                                    <a class="td-button" href="#" @click.prevent="
                                        mn = spreads.other.mn;
                                    loadChart = spreads.other.isinid;
                                    orderTab = 'Charts';
                                    ">
                                        <feather size="12px" type="bar-chart-2"></feather>
                                    </a>
                                    <a class="td-button" href="#"
                                        :class="[{ favSelected: fevList.includes(spreads.other.isinid) }]"
                                        v-if="watchId">
                                        <feather size="12px" type="star"
                                            @click.stop.prevent="addRemFev(spreads.other.isinid)"></feather>
                                    </a>
                                </span>
                            </td>
                        </tr>
                        <tr v-if="dataList(get_currencies).length == 0">
                            <td class="noData border-0 h-100" colspan="11">
                                <app-loader v-if="pageLoader" />
                                <no-data class="text-center" v-else :text="subList.length > 0
                                        ? 'Opps! <span>No Data</span>'
                                        : 'Opps! <span>No Data</span> Add ISINS in watch list'
                                    " />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <trading-view :loadChart="loadChart" :mn="mn" v-if="!showChart && orderTab == 'Charts'"></trading-view>
            <chart-iq class="responsiveTable scrollbar bottomTable" :loadChart="loadChart" :mn="mn"
                v-else-if="orderTab == 'Charts'"></chart-iq>
            <div class="tradeLog">
                <app-order-history v-show="orderTab == 'Trade'" :pageLimit="13" />
            </div>
        </div>
        <!--Add New WatchList-->
        <div class="customFixed-vue darkFadeBG selectWatch-pop" v-if="showCreateWatch">
            <div class="custom-modal showTabs secondary-color headerTab newsResize openWatchlist">
                <span class="closePOP" @click.prevent="
                    showCreateWatch = false;
                clearCreateWatch();
                ">
                    <feather size="13px" type="x"></feather>
                </span>
                <div class="pop-head-title">
                    <p class="mb-3">{{ $t('new_watchlist') }}</p>
                </div>
                <div class="topSettingHead position-relative border-bottom p-3 text-center updateWrap"
                    v-if="watchListData.length >= 6">
                    <app-loader v-if="pageLoader" />
                    <div class="fields-wrappers">
                        <div class="ppSuccess-icon text-center mt-3 mb-2">
                            <feather size="28px" type="info"></feather>
                        </div>
                        <p class="mb-3">{{ $t('maximum_5_watchlists') }}</p>
                        <!-- <button class="btn appButton linkBG justify-content-center mt-4 mx-auto" @click="clearCreateWatch()">Create New Watchlist</button> -->
                        <!-- <a href="#" class="noAdd">No</a> -->
                    </div>
                </div>
                <div class="topSettingHead position-relative border-bottom p-3 updateWrap"
                    v-else-if="!createWatchSuccess">
                    <app-loader v-if="pageLoader" />
                    <div class="form-fields">
                        <input type="text" class="form-controls" placeholder="Watchlist Name" name="watchlist"
                            v-model="newWatchName" v-validate="'required|max:25'" maxlength="20" />
                        <span class="text-danger" v-if="submitted && errors.has('watchlist')">{{
                            errors.first("watchlist")
                            }}</span>
                        <button class="btn appButton linkBG mx-auto justify-content-center mt-4" @click="AdWAtch()"
                            :disabled="pageLoader">
                            {{ $t('watchlist_create') }}
                        </button>
                    </div>
                </div>
                <div class="topSettingHead position-relative border-bottom p-3 text-center updateWrap" v-else>
                    <app-loader v-if="pageLoader" />
                    <div class="fields-wrappers">
                        <div class="ppSuccess-icon text-center mt-0 mb-2">
                            <div class="checkmarkAnimated">
                                <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 161.2 161.2"
                                    enable-background="new 0 0 161.2 161.2" xml:space="preserve">
                                    <path class="path" fill="none" stroke="#10bd72" stroke-miterlimit="10" d="M425.9,52.1L425.9,52.1c-2.2-2.6-6-2.6-8.3-0.1l-42.7,46.2l-14.3-16.4
                                    c-2.3-2.7-6.2-2.7-8.6-0.1c-1.9,2.1-2,5.6-0.1,7.7l17.6,20.3c0.2,0.3,0.4,0.6,0.6,0.9c1.8,2,4.4,2.5,6.6,1.4c0.7-0.3,1.4-0.8,2-1.5
                                    c0.3-0.3,0.5-0.6,0.7-0.9l46.3-50.1C427.7,57.5,427.7,54.2,425.9,52.1z" />
                                    <circle class="path" fill="none" stroke="#10bd72" stroke-width="4"
                                        stroke-miterlimit="10" cx="80.6" cy="80.6" r="62.1" />
                                    <polyline class="path" fill="none" stroke="#10bd72" stroke-width="6"
                                        stroke-linecap="round" stroke-miterlimit="10" points="113,52.8 
                                    74.1,108.4 48.2,86.4 " />

                                    <circle class="spin" fill="none" stroke="#10bd72" stroke-width="4"
                                        stroke-miterlimit="10" stroke-dasharray="12.2175,12.2175" cx="80.6" cy="80.6"
                                        r="73.9" />
                                </svg>
                            </div>
                        </div>
                        <h3 class="mb-3 green">{{$t('new_watchlist_successfully')}}</h3>
                        <button class="btn appButton linkBG justify-content-center mt-4 mx-auto" @click="
                            showCreateWatch = false;
                        clearCreateWatch();
                        ">
                            {{$t('close')}}
                        </button>
                        <!-- <a href="#" class="noAdd">No</a> -->
                    </div>
                </div>
            </div>
        </div>
        <!-- Delete WatchList-->
        <div class="customFixed-vue darkFadeBG selectWatch-pop" v-if="Object.keys(delWatchData).length > 0">
            <div class="custom-modal showTabs secondary-color headerTab newsResize openWatchlist">
                <span class="closePOP" @click.prevent="
                    delWatchData = {};
                delWatchSuccess = false;
                ">
                    <feather size="13px" type="x"></feather>
                </span>
                <div class="pop-head-title">
                    <p class="mb-3">{{$t('delete_watchlist')}}</p>
                </div>
                <div class="topSettingHead position-relative border-bottom p-3 text-center updateWrap"
                    v-if="!delWatchSuccess">
                    <app-loader v-if="pageLoader" />
                    <div class="ppSuccess-icon text-center mt-0 mb-2">
                        <feather class="red" size="28px" type="trash-2"></feather>
                    </div>
                    <div class="fields-wrappers">
                        <p class="mb-3">{{$t('delete_watchlist?')}}</p>
                        <div class="d-flex align-items-center justify-content-center mt-4">
                            <button href="#" class="noAdd white mr-3" @click="delWatchData = {}">
                                {{$t('no')}}
                            </button>
                            <button class="btn appButton linkBG justify-content-center" @click="delWAtch()">
                                {{$t('yes')}}
                            </button>
                        </div>
                    </div>
                </div>
                <div class="topSettingHead position-relative border-bottom p-3 text-center updateWrap" v-else>
                    <app-loader v-if="pageLoader" />
                    <div class="fields-wrappers">
                        <div class="ppSuccess-icon text-center mt-0 mb-2">
                            <div class="checkmarkAnimated">
                                <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 161.2 161.2"
                                    enable-background="new 0 0 161.2 161.2" xml:space="preserve">
                                    <path class="path" fill="none" stroke="#10bd72" stroke-miterlimit="10" d="M425.9,52.1L425.9,52.1c-2.2-2.6-6-2.6-8.3-0.1l-42.7,46.2l-14.3-16.4
                                    c-2.3-2.7-6.2-2.7-8.6-0.1c-1.9,2.1-2,5.6-0.1,7.7l17.6,20.3c0.2,0.3,0.4,0.6,0.6,0.9c1.8,2,4.4,2.5,6.6,1.4c0.7-0.3,1.4-0.8,2-1.5
                                    c0.3-0.3,0.5-0.6,0.7-0.9l46.3-50.1C427.7,57.5,427.7,54.2,425.9,52.1z" />
                                    <circle class="path" fill="none" stroke="#10bd72" stroke-width="4"
                                        stroke-miterlimit="10" cx="80.6" cy="80.6" r="62.1" />
                                    <polyline class="path" fill="none" stroke="#10bd72" stroke-width="6"
                                        stroke-linecap="round" stroke-miterlimit="10" points="113,52.8 
                                    74.1,108.4 48.2,86.4 " />

                                    <circle class="spin" fill="none" stroke="#10bd72" stroke-width="4"
                                        stroke-miterlimit="10" stroke-dasharray="12.2175,12.2175" cx="80.6" cy="80.6"
                                        r="73.9" />
                                </svg>
                            </div>
                        </div>
                        <p class="mb-3">{{$t('delete_watchlist_successfully')}}</p>
                        <button class="btn appButton linkBG justify-content-center mt-4 mx-auto" @click="
                            delWatchData = {};
                        delWatchSuccess = false;
                        ">
                            {{$t('close')}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!--Edit WatchList-->
        <div class="customFixed-vue darkFadeBG selectWatch-pop" v-if="Object.keys(editWatchData).length > 0">
            <div class="custom-modal showTabs secondary-color headerTab newsResize openWatchlist">
                <span class="closePOP" @click.prevent="
                    editWatchData = {};
                editWatchSuccess = false;
                ">
                    <feather size="13px" type="x"></feather>
                </span>
                <div class="pop-head-title">
                    <p class="mb-3">{{$t('edit_watchlist')}}</p>
                </div>
                <div class="topSettingHead position-relative border-bottom p-3 updateWrap" v-if="!editWatchSuccess">
                    <app-loader v-if="pageLoader" />
                    <div class="form-fields">
                        <input type="text" class="form-controls" placeholder="Watchlist Name" name="watchlist"
                            v-model="editWatchData.name" v-validate="'required|max:25'" maxlength="20" />
                        <span class="text-danger" v-if="submitted && errors.has('watchlist')">{{
                            errors.first("watchlist")
                            }}</span>
                        <button class="btn appButton linkBG mx-auto justify-content-center mt-4" @click="editWAtch()"
                            :disabled="pageLoader">
                            {{$t('edit_watchlist')}}
                        </button>
                    </div>
                </div>
                <div class="topSettingHead position-relative border-bottom p-3 text-center updateWrap" v-else>
                    <app-loader v-if="pageLoader" />
                    <div class="fields-wrappers">
                        <div class="ppSuccess-icon text-center mt-0 mb-2">
                            <div class="checkmarkAnimated">
                                <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 161.2 161.2"
                                    enable-background="new 0 0 161.2 161.2" xml:space="preserve">
                                    <path class="path" fill="none" stroke="#10bd72" stroke-miterlimit="10" d="M425.9,52.1L425.9,52.1c-2.2-2.6-6-2.6-8.3-0.1l-42.7,46.2l-14.3-16.4
                                    c-2.3-2.7-6.2-2.7-8.6-0.1c-1.9,2.1-2,5.6-0.1,7.7l17.6,20.3c0.2,0.3,0.4,0.6,0.6,0.9c1.8,2,4.4,2.5,6.6,1.4c0.7-0.3,1.4-0.8,2-1.5
                                    c0.3-0.3,0.5-0.6,0.7-0.9l46.3-50.1C427.7,57.5,427.7,54.2,425.9,52.1z" />
                                    <circle class="path" fill="none" stroke="#10bd72" stroke-width="4"
                                        stroke-miterlimit="10" cx="80.6" cy="80.6" r="62.1" />
                                    <polyline class="path" fill="none" stroke="#10bd72" stroke-width="6"
                                        stroke-linecap="round" stroke-miterlimit="10" points="113,52.8 
                                    74.1,108.4 48.2,86.4 " />

                                    <circle class="spin" fill="none" stroke="#10bd72" stroke-width="4"
                                        stroke-miterlimit="10" stroke-dasharray="12.2175,12.2175" cx="80.6" cy="80.6"
                                        r="73.9" />
                                </svg>
                            </div>
                        </div>
                        <p class="mb-3">{{$t('watchlist_updated_successfully')}}</p>
                        <button class="btn appButton linkBG justify-content-center mt-4 mx-auto" @click="
                            editWatchData = {};
                        editWatchSuccess = false;
                        ">
                            {{$t('close')}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!--Sell Oreder PLaces -->
        <div class="customFixed-vue darkFadeBG selectWatch-pop" v-if="orderPlced">
            <div class="custom-modal showTabs secondary-color headerTab newsResize openWatchlist">
                <span class="closePOP" @click.prevent="orderPlced = false">
                    <feather size="13px" type="x"></feather>
                </span>

                <div class="topSettingHead position-relative border-bottom p-3 text-center updateWrap"
                    v-if="!wsOrder.hasOwnProperty(tempOrderId)">
                    <div class="fields-wrappers">
                        <div class="ppSuccess-icon text-center mt-3 mb-2">
                            <feather size="28px" type="clock"></feather>
                        </div>
                        <p class="mb-3">{{ $t('placed_order_pending_wait') }}</p>
                        <a href="#" class="btn appButton linkBG justify-content-center mt-4 mx-auto"
                            @click.prevent="orderPlced = false">{{$t('go_to_order')}}</a>
                        <!-- <a href="#" class="noAdd">No</a> -->
                    </div>
                </div>
                <div class="topSettingHead position-relative border-bottom p-3 text-center updateWrap" v-else>
                    <div class="fields-wrapper">
                        <div class="ppSuccess-icon text-center mt-3 mb-2 d-flex justify-content-center">
                            <div class="checkmarkAnimated" v-if="wsOrder[tempOrderId].stat == 'OK'">
                                <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 161.2 161.2"
                                    enable-background="new 0 0 161.2 161.2" xml:space="preserve">
                                    <path class="path" fill="none" stroke="#10bd72" stroke-miterlimit="10" d="M425.9,52.1L425.9,52.1c-2.2-2.6-6-2.6-8.3-0.1l-42.7,46.2l-14.3-16.4
                                    c-2.3-2.7-6.2-2.7-8.6-0.1c-1.9,2.1-2,5.6-0.1,7.7l17.6,20.3c0.2,0.3,0.4,0.6,0.6,0.9c1.8,2,4.4,2.5,6.6,1.4c0.7-0.3,1.4-0.8,2-1.5
                                    c0.3-0.3,0.5-0.6,0.7-0.9l46.3-50.1C427.7,57.5,427.7,54.2,425.9,52.1z" />
                                    <circle class="path" fill="none" stroke="#10bd72" stroke-width="4"
                                        stroke-miterlimit="10" cx="80.6" cy="80.6" r="62.1" />
                                    <polyline class="path" fill="none" stroke="#10bd72" stroke-width="6"
                                        stroke-linecap="round" stroke-miterlimit="10" points="113,52.8 
                                    74.1,108.4 48.2,86.4 " />

                                    <circle class="spin" fill="none" stroke="#10bd72" stroke-width="4"
                                        stroke-miterlimit="10" stroke-dasharray="12.2175,12.2175" cx="80.6" cy="80.6"
                                        r="73.9" />
                                </svg>
                            </div>
                            <feather size="28px" type="alert-triangle" v-else></feather>
                        </div>
                        <p class="mb-3" v-html="wsOrder[tempOrderId].resp_msg"></p>
                        <!--  :class="(wsOrder.stat == 'OK')?'green':'red'" -->
                        <a href="#" class="btn appButton linkBG justify-content-center mt-4 mx-auto"
                            @click.prevent="orderPlced = false">{{$t('go_to_order')}}</a>
                        <!-- <a href="#" class="noAdd">No</a> -->
                    </div>
                </div>
            </div>
        </div>
        <div class="customFixed-vue darkFadeBG" v-if="detailISIN">
            <div class="custom-modal showTabs secondary-color headerTab">
                <span class="closePOP" @click="detailISIN = ''">
                    <feather size="13px" type="x"></feather>
                </span>
                <div class="mainContent position-relative">
                    <div class="mainTab-prformancs">
                        <!--  v-if="statement == 'Account Statement'" -->
                        <div class="btInfo" v-if="get_currencies[detailISIN]">
                            <div class="infoBasic text-center border-bottom py-4">
                                <h3 class="d-flex align-items-center justify-content-center">
                                    {{ detailISIN }} <span class="sm value">{{ $t('search_filter_fx') }}</span>
                                </h3>
                                <p class="m-0 sm">{{ get_currencies[detailISIN].other.Description }}</p>
                            </div>
                            <div class="idfoDtails d-flex">
                                <ul class="d-flex justify-content-between flex-wrap twoColmn-mn">
                                    <li>
                                        <span class="ruleAdd f-12">{{ $t('asset_class') }}</span>
                                        <p class="f-14">
                                            {{ assetType[get_currencies[detailISIN].other.type.toLowerCase()] || get_currencies[detailISIN].other.type}}
                                        </p>
                                    </li>
                                    <li>
                                        <span class="ruleAdd f-12">{{ $t('subclass') }}</span>
                                        <p class="f-14">{{$t('major')}}</p>
                                    </li>

                                    <li>
                                        <span class="ruleAdd f-12">{{$t('size_of_1_pip')}}</span>
                                        <p class="f-14">{{ get_currencies[detailISIN].other.pip_size }}</p>
                                    </li>
                                    <li>
                                        <span class="ruleAdd f-12">{{$t('contract_size')}}</span>
                                        <p class="f-14">
                                            {{ get_currencies[detailISIN].other.Contract_Size }}
                                        </p>
                                    </li>
                                    <li>
                                        <span class="ruleAdd f-12">{{$t('Min_position_size')}}</span>
                                        <p class="f-14">
                                            {{ get_currencies[detailISIN].other.Min_Trade_Size }}
                                        </p>
                                    </li>
                                    <li>
                                        <span class="ruleAdd f-12">{{$t('Max_position_size')}}</span>
                                        <p class="f-14">
                                            {{ get_currencies[detailISIN].other.Max_Trade_Size }}
                                        </p>
                                    </li>
                                    <li>
                                        <span class="ruleAdd f-12">{{$t('commission')}}</span>
                                        <p class="f-14">0</p>
                                    </li>
                                    <li>
                                        <span class="ruleAdd f-12">{{$t('leverage')}}</span>
                                        <p class="f-14">{{ get_currencies[detailISIN].other.levPRF }}x</p>
                                    </li>
                                    <li>
                                        <span class="ruleAdd f-12">{{$t('daily_swap_points')}}</span>
                                        <p class="f-14 mb-1">
                                            {{$t('long')}}: {{ get_currencies[detailISIN].other.Long_Swaps }}
                                        </p>
                                    </li>
                                    <li>
                                        <br />
                                        <p class="f-14">
                                            {{$t('short')}}: {{ get_currencies[detailISIN].other.Short_Swaps }}
                                        </p>
                                    </li>
                                </ul>
                                <ul class="oneColmn-mn">
                                    <li>
                                        <span class="ruleAdd f-12">{{$t('market_hours_local_time')}}</span>
                                        <p class="f-14 d-flex align-items-center justify-content-between"
                                            v-for="(val, key) in get_currencies[detailISIN].other"
                                            v-if="key == 'Trading  Hours'">
                                            <span class="mtV">{{ val }}</span>
                                        </p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!---Close Modal-->
        <!-- <sidebar-popup :tab="headerTab" v-if="headerTab != ''"></sidebar-popup> -->
        <!-- <div class="customFixed-vue darkFadeBG loginInfo d-none" :class="alertpop?'active':' '">
            <div class="custom-modal showTabs secondary-color openHeader">
                <div class="mainContent">
                    <div class="topSettingHead position-relative border-bottom p-3">
                        <p class="f-14 mb-0">ID: #2454043</p>
                        <span class="closePOP" @click="alertpop = false"><feather type="x"></feather> </span>
                    </div>
                    <div class="mainTab-one text-center my-3">
                        <feather type="check-circle"></feather>
                        <p class="mt-2">Order has been placed Successfully</p>
                        <div class="orderID mt-2">
                            <p>Price <span class="f-14">2450.404UD</span></p>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
    </div>
</template>
<script>
import buy_sell from "../shared/buy-sell";
// import chart_section from "./elements/chart-section";
import chart_iq from "../shared/chart-iq";
import trading_view from "../shared/trading-view";
import order_history from "../shared/order/order-history";
import { Const } from "@/plugins/vue-provider-cache/const.mod";
import { commonAllmixins } from "@/plugins/commonAll";
const product_type = process.env.product_type;
export default {
    name: "grid-view",
    mixins: [commonAllmixins],
    data() {
        return {
            order: "Market Watch",
            chartType: "USD-BTC",
            headerTab: "",
            statement: "Account Statement",
            oneClickTrade: false,
            editWatchlist: false,
            alertpop: false,
            orderTab: "Market",
            openOrder: "open",
            filterOption: false,
            modifyOrder: true,
            dfUsed: false,
            pendingOrder: false,
            hedgePosition: false,
            loadChart: "EURUSD" + product_type,
            mn: "EURUSD" + product_type,
            page: "1",

            tradeBuySell: false,
            buySellType: "buy",
            currency_pair: "",
            pairDetail: "",
            detailISIN: "",

            pageLoader: false,
            submitted: false,
            // watchlist
            watchbtnShow: [],
            subList: [],
            watchId: null,
            // creat watch List
            showCreateWatch: false,
            newWatchName: "",
            createWatchSuccess: false,
            // delete watch List
            delWatchData: {},
            delWatchSuccess: false,
            // Update watch List
            editWatchData: {},
            editWatchSuccess: false,
            // fevorite List
            shoWFev: false,
            fevList: [],
            // one click trade
            onClickList: {},
            orderPlced: false,
            orderPending: {},
            tempOrderId: "",
            // search variable
            filterCrypto: "",
            focusSearch: false,
            assetType: {
                currencies: "Forex",
                commodities: "Commodities",
                indicies: "Indicies",
                forex: "Forex",
                crypto: "Crypto",
            },
        };
    },
    components: {
        appBuySell: buy_sell,
        // chartSection: chart_section,
        chartIq: chart_iq,
        tradingView: trading_view,
        appOrderHistory: order_history,
    },
    watch: {
        subList(val) {
            this.changeClickList();
            this.callWatchList(val);
        },
        userSettings(val) {
            if (this.userSettings.lotsize) {
                this.changeClickList();
            }
        },
    },
    methods: {
        getSpread(spreads) {
            try {
                return parseFloat(Math.abs((spreads.B || 0) - (spreads.A || 0))).toFixed(
                    spreads.other.Min_Trade_Size.split(".")[1].length
                );
            } catch (e) {
                return "-";
            }
        },
        showdata(spreads) {
            // console.log(spreads)
        },
        displayError(getMessage, type) {
            this.$notify({
                group: "foo",
                type: type && type == null ? "error" : type,
                text: getMessage,
                duration: 3000,
                closeOnClick: true,
            });
        },
        changeLoadChart(val) {
            try {
                this.mn = this.currencyPairs.filter((value) => value.isinid.includes(val))[0].mn;
            } catch (e) { }
            this.loadChart = val;
        },
        filtercurr() {
            try {
                return this.currencyPairs.filter((spreads) =>
                    spreads.isinid.toLowerCase().includes(this.filterCrypto.toLowerCase())
                );
            } catch (e) {
                return [];
            }
        },
        closeDetail() {
            alert(this.detailISIN);
            this.detailISIN = "";
            alert("1", this.detailISIN);
        },
        keyUpStep(e, name, varName) {
            if (parseFloat(this.onClickList[name][varName]) == 0 && e.key == "ArrowDown") {
                this.onClickList[name][varName] = this.get_currencies[name].A;
            }
            // e.preventDefault();
        },
        changeStep(name, type, varName) {
            if (type == 1) {
                document.getElementById(name + "_" + varName).stepUp();
                this.onClickList[name][varName] = document.getElementById(
                    name + "_" + varName
                ).value;
            } else if (type == 0) {
                if (["SL", "TP"].includes(varName) && !this.onClickList[name][varName]) {
                    this.onClickList[name][varName] = this.get_currencies[name].A;
                } else {
                    document.getElementById(name + "_" + varName).stepDown();
                    this.onClickList[name][varName] = document.getElementById(
                        name + "_" + varName
                    ).value;
                }
            }
        },
        getStep(val, instruments) {
            let data = instruments.A;
            if (val == "" || parseFloat(val) == 0) {
                return parseFloat(data).toString();
            } else if (val && data.toString().includes(".")) {
                return 1 / Math.pow(10, data.toString().split(".")[1].length);
            } else {
                return "1";
            }
        },
        openBuySell(type, pair) {
            this.tradeBuySell = true;
            this.buySellType = type;
            this.currency_pair = pair;
        },
        AddRemIndex(value) {
            if (this.indexNo == value) {
                this.indexNo = "";
            } else {
                this.indexNo = value;
            }
        },
        successWs() {
            this.orderPlced = true;
        },
        failedWs() {
            this.displayError("some network issue", "error");
            // this.orderPending = ''
            // this.tempOrderId = {}
            // console.log('failed order')
        },
        displayError(getMessage, type) {
            this.$notify({
                group: "foo",
                type: type && type == null ? "error" : type,
                text: getMessage,
                duration: 2000,
                closeOnClick: true,
            });
        },
        quantityValidation(spreads, val, instruments) {
            this.onClickList[spreads].lot = val.toString().replaceAll(/[^\d.]/g, "");
            let upper = 3,
                lower = 3;
            try {
                upper = instruments.other.Max_Trade_Size.length;
            } catch (e) { }
            try {
                lower = instruments.other.Min_Trade_Size.split(".")[1].length;
            } catch (e) { }
            if (val.toString().includes(".")) {
                this.onClickList[spreads].lot =
                    val.toString().split(".")[0].slice(0, upper) +
                    "." +
                    val.toString().split(".")[1].slice(0, lower);
            } else {
                this.onClickList[spreads].lot = val.toString().slice(0, upper);
            }
        },
        changeValidation(spreads, val, name, instruments) {
            this.onClickList[spreads][name] = val.toString().replaceAll(/[^\d.]/g, "");
            let upper = 5,
                lower = 5;
            try {
                upper = instruments.B.split(".")[0].length;
            } catch (e) { }
            try {
                lower = instruments.other.Tick_Size.split(".")[1].length;
            } catch (e) { }
            if (val.toString().includes(".")) {
                this.onClickList[spreads][name] =
                    val.toString().split(".")[0].slice(0, upper) +
                    "." +
                    val.toString().split(".")[1].slice(0, lower);
            } else {
                this.onClickList[spreads][name] = val.toString().slice(0, upper);
            }
        },
        addErrorMsg(id) {
            if (!$("#" + id).hasClass("validation-error")) {
                $("#" + id).addClass("validation-error");
            }
        },
        removeErrorMsg(id) {
            if ($("#" + id).hasClass("validation-error")) {
                $("#" + id).removeClass("validation-error");
            }
        },
        oneclickError(getMessage, type) {
            this.$notify({
                group: "whitelist",
                type: type && type == null ? "error" : type,
                text: getMessage,
                duration: 4000,
                closeOnClick: true,
            });
        },
        oneClickOrder(spreads, side, priceData) {
            this.removeErrorMsg(spreads + "_form_SL");
            this.removeErrorMsg(spreads + "_form_TP");
            this.removeErrorMsg(spreads + "_form_lot");
            if (
                this.onClickList[spreads] &&
                this.onClickList[spreads].lot &&
                this.onClickList[spreads].lot > 0
            ) {
                if (side == 1) {
                    if (
                        !(this.onClickList[spreads].SL < priceData.A) ||
                        this.onClickList[spreads].SL < 0
                    ) {
                        document.getElementById(spreads + "_SL").focus();
                        this.addErrorMsg(spreads + "_form_SL");
                        this.oneclickError("Stop loss must be null or less then Sell Price", "error");
                        return;
                    }
                    if (
                        (!(this.onClickList[spreads].TP > priceData.A) ||
                            this.onClickList[spreads].TP < 0) &&
                        !(this.onClickList[spreads].TP == 0)
                    ) {
                        document.getElementById(spreads + "_TP").focus();
                        this.addErrorMsg(spreads + "_form_TP");
                        this.oneclickError(
                            "Target price must be null or greater then Sell Price",
                            "error"
                        );
                        return;
                    }
                } else if (side == 0) {
                    if (
                        (!(this.onClickList[spreads].SL > priceData.B) ||
                            this.onClickList[spreads].SL < 0) &&
                        !(this.onClickList[spreads].SL == 0)
                    ) {
                        document.getElementById(spreads + "_SL").focus();
                        this.addErrorMsg(spreads + "_form_SL");
                        this.oneclickError(
                            "Stop loss must be null or greater then Buy Price",
                            "error"
                        );
                        return;
                    }
                    if (
                        !(this.onClickList[spreads].TP < priceData.B) ||
                        this.onClickList[spreads].TP < 0
                    ) {
                        document.getElementById(spreads + "_TP").focus();
                        this.addErrorMsg(spreads + "_form_TP");
                        this.oneclickError(
                            "Target price must be null or less then Buy Price",
                            "error"
                        );
                        return;
                    }
                }
                if (this.onClickList[spreads].lot > parseFloat(priceData.other.Max_Trade_Size)) {
                    this.addErrorMsg(spreads + "_form_lot");
                    this.oneclickError(
                        "Lot size shuld be maximum " + priceData.other.Max_Trade_Size,
                        "error"
                    );
                    return;
                }
                this.$store.commit("SET_WS_ORDER", {});
                const tempOrderId = new Date().getTime();
                let orderJson = {
                    symbol: spreads,
                    quantity: parseFloat(this.onClickList[spreads].lot),
                    side: side,
                    stop: parseFloat(this.onClickList[spreads].SL || 0),
                    limit: parseFloat(this.onClickList[spreads].TP || 0),
                    trail: 0,
                    commentary: "",
                    account_id: this.get_user.profile.act_account_id,
                    tempOrderId: tempOrderId,
                    localParams: this,
                };
                // console.log('order',orderJson)
                this.$store.getters[Const.GET_PROVIDERS]["priceFeed"].seeders[
                    "S_PF_PF"
                ].placeOrder(orderJson);
                this.orderPending = orderJson;
                this.tempOrderId = this.orderPending.tempOrderId;
            } else {
                document.getElementById(spreads + "_lot").focus();
                this.addErrorMsg(spreads + "_form_lot");
                this.oneclickError("please enter valid lot size", "error");
            }
        },
        changeClickList() {
            this.onClickList = {};
            if (this.userSettings.lotsize) {
                this.subList.forEach((val) => {
                    this.onClickList[val] = { SL: "", TP: "", lot: this.userSettings.lotsize };
                });
            } else {
                this.subList.forEach((val) => {
                    let lot = 0.01;
                    if (this.get_currencies[val]) {
                        lot = this.get_currencies[val].other.Min_Trade_Size;
                    }
                    this.onClickList[val] = { SL: "", TP: "", lot: lot };
                });
            }
        },
        editWAtch() {
            let inputJson = {
                globalParams: {
                    id: this.editWatchData._id,
                    name: this.editWatchData.name,
                },
                localParams: { parameter: this },
            };
            this._runUpdateWatchList(inputJson);
        },
        delWAtch() {
            let inputJson = {
                globalParams: {
                    id: this.delWatchData._id,
                },
                localParams: { parameter: this },
            };
            this._runDeleteWatchList(inputJson);
        },
        clearCreateWatch() {
            this.submitted = false;
            this.newWatchName = "";
            this.createWatchSuccess = false;
        },
        AdWAtch() {
            let _that = this;
            this.submited = true;
            this.$validator.validate().then((valid) => {
                if (valid) {
                    let inputJson = {
                        globalParams: {
                            name: _that.newWatchName,
                        },
                        localParams: { parameter: _that },
                    };
                    _that._runCreateWatchList(inputJson);
                }
            });
        },
        getwatchName(watchId) {
            try {
                return this.watchListData.filter((val) => val._id === watchId)[0].name;
            } catch (e) {
                return "-";
            }
        },
        setWatch(list) {
            this.callWatchList(list.subscribe ? list.subscribe : []);
            this.watchId = list._id;
            this.subList = list.subscribe ? list.subscribe : [];
            this.fevList = list.is_fav ? list.is_fav : [];
            localStorage.removeItem("watchId");
            localStorage.removeItem("subList");
            if (this.watchId == null) {
                localStorage.setItem("watchId", "null");
            } else {
                localStorage.setItem("watchId", this.watchId);
            }
            localStorage.setItem("subList", JSON.stringify(this.subList));
            // if(this.subList.length > 0){}
        },
        callWatchList(list) {
            if (list) {
                let _that = this;
                try {
                    _that.$store.getters[Const.GET_PROVIDERS]["priceFeed"].seeders[
                        "S_PF_PF"
                    ].watchlist(list);
                    if (list.length) {
                        if (!list.includes(_that.loadChart)) {
                            _that.changeLoadChart(list[0]);
                        }
                    }
                } catch (e) {
                    var interval = setInterval(function () {
                        try {
                            _that.$store.getters[Const.GET_PROVIDERS]["priceFeed"].seeders[
                                "S_PF_PF"
                            ].watchlist(list);
                            if (list.length) {
                                if (!list.includes(_that.loadChart)) {
                                    _that.changeLoadChart(list[0]);
                                }
                            }
                            clearInterval(interval);
                        } catch (e) { }
                    }, 500);
                }
            }
        },
        addRemSubscribe(item) {
            let itemData = { isins: [item], id: this.watchId };
            if (this.subList.includes(item)) {
                this.subList = this.subList.filter((val) => val != item);
                this.$store.getters[Const.GET_PROVIDERS]["priceFeed"].seeders[
                    "S_PF_PF"
                ].unsubscribe(itemData);
                if (
                    this.loadChart == item &&
                    !this.subList.includes(this.loadChart) &&
                    this.subList.length > 0
                ) {
                    this.changeLoadChart(this.subList[0]);
                }
            } else if (this.subList.length <= 20) {
                this.subList.push(item);
                // console.log('subscribe',itemData)
                this.$store.getters[Const.GET_PROVIDERS]["priceFeed"].seeders[
                    "S_PF_PF"
                ].subscribe(itemData);
            } else if (this.subList.length >= 20) {
                this.displayError("you can add maximum 20 pair's in one Watch List", "error");
            }
            let watchListData = [...this.watchListData];
            watchListData.forEach((val, index) => {
                if (val._id === this.watchId) {
                    watchListData[index].subscribe = this.subList;
                    localStorage.setItem("subList", JSON.stringify(this.subList));
                }
            });
            this.$store.commit("/SET_WATCH_LIST", watchListData);
        },
        addRemFev(item) {
            let itemData = { isins: [item], id: this.watchId };
            if (this.fevList.includes(item)) {
                this.fevList = this.fevList.filter((val) => val != item);
                this.$store.getters[Const.GET_PROVIDERS]["priceFeed"].seeders[
                    "S_PF_PF"
                ].removeFavorite(itemData);
            } else if (this.fevList.length <= 20) {
                this.fevList.push(item);
                this.$store.getters[Const.GET_PROVIDERS]["priceFeed"].seeders[
                    "S_PF_PF"
                ].addFavorite(itemData);
            } else if (this.subList.length >= 20) {
                this.displayError("you can add maximum 20 pair's in fevorite List", "error");
            }
            let watchListData = [...this.watchListData];
            watchListData.forEach((val, index) => {
                if (val._id === this.watchId) {
                    watchListData[index].is_fav = this.fevList;
                }
            });
            // console.log(item,this.fevList,watchListData)
            this.$store.commit("/SET_WATCH_LIST", watchListData);
        },
        drag(ev, data) {
            ev.dataTransfer.setData("marketData", data);
        },
        openBuySell(type, pair) {
            this.tradeBuySell = true;
            this.buySellType = type;
            this.currency_pair = pair;
        },
        isMobileGrid() {
            if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                return true
            } else {
                return false
            }
        },

        dataList(value) {
            var data = Object.values(value);
            const priority = {
                forex: 1,
                indicies: 2,
                commodities: 3,
                crypto: 4
            };
            try {
                if (data.length > 0) {
                    var _that = this;
                    return data.filter((val) => {
                        return (
                            this.subList.includes(val.other.isinid) &&
                            (!this.shoWFev || this.fevList.includes(val.other.isinid))
                        );
                    }).sort((a, b) => {
                        const priorityDiff = priority[a.other.type.toLowerCase()] - priority[b.other.type.toLowerCase()];
                        if (priorityDiff === 0) {
                            return a.other.isinid.localeCompare(b.other.isinid);
                        }
                        return priorityDiff;
                    });
                } else {
                    return [];
                }
            } catch (e) {
                return [];
            }
        },
        watchLiting() {
            this._runGetWatchList({ globalParams: {}, localParams: { parameter: this } });
        },
    },
    computed: {
        get_currencies() {
            try {
                // just 'feel' the pulse here so we get a reactive response
                // as the cache is not reactive
                this.$store.getters[Const.GET_HEARTBEATS]["priceFeed"];
                return this.$store.getters[Const.GET_PROVIDERS][
                    "priceFeed"
                ].iCache.asKeysValueArrayAll();
            } catch (ex) {
                // console.log('OO-one [ex]', ex)
                return [];
            }
        },
    },
    mounted() {
        const _that = this;
        $(document).on("click", function (event) {
            if (!$(event.target).closest(".openBuySell").length) {
                _that.buySell = "";
                _that.tradeBuySell = false;
            }
            if (!$(event.target).closest(".searchIsinFilter").length) {
                _that.filterCrypto = "";
                _that.focusSearch = false;
            }
        });
    },
    created() {
        let _that = this;
        if (localStorage.getItem("watchId")) {
            let watchId = localStorage.getItem("watchId");
            this.watchId = watchId == "null" ? null : watchId;
        }
        if (localStorage.getItem("subList")) {
            this.subList = JSON.parse(localStorage.getItem("subList"));
            this.callWatchList(this.subList);
        }
        if (this.watchListData.length > 0) {
            let idFound = false;
            this.watchListData.forEach((val, index) => {
                if (val._id === this.watchId) {
                    idFound = true;
                    this.fevList = val.is_fav ? val.is_fav : [];
                    this.setWatch(val);
                }
                if (index == this.watchListData.length - 1 && !idFound) {
                    this.setWatch(this.watchListData[0]);
                }
            });
        }
        this._runGetCurrencyPairs({ globalParams: {}, localParams: { parameter: this } });
        this.watchLiting();
    },
};
</script>
<style>
.searchList {
    min-height: 150px;
    max-height: 200px;
    overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/website/grid-view/grid-view.vue